//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goConsultant from '@/common/mixins/goConsultant'
import callConsultant from '@/common/mixins/callConsultant'
import { openChat } from '@/data/im'
import { sendCtmEvtLog } from '@/_base/log'

export default {
    mixins: [
        goConsultant,
        callConsultant
    ],
    props: {
        title: {
            type: String
        },
        show_help: {
            type: Boolean,
            default: false
        },
        excellent_consultants: {
            type: Array,
            default: []
        },
        is_default: {
            type: Boolean,
            default: true
        },
        building_id: {
            type: [Number, String]
        },
        show_consultants_auth: {
            type: Boolean,
            default: true
        },
        page: String,
        show_hd: {
            type: Boolean,
            default: true
        },
        horizontal: {
            type: Boolean,
            default: true
        },
        classname: String,
        show_mini_btn: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goConsultantHelp () {
            wx.navigateTo({
                url: `/consultants/recommend_rules/main?building_id=${this.building_id}`
            })
        },
        onCall (e) {
            this.callConsultant(e)
        },
        onConsult (id, i) {
            const { path, query } = this.$route
            const { type } = query
            const PAGE_MAP = {
                '/building': '楼盘详情页',
                '/building/info/main': '楼盘详细信息页',
                '/building/img_preview/main': {
                    'common': '楼盘图片页',
                    'layout': '户型图页'
                },
                '/building/material/main': '购房资料页',
                '/building/price_detail/main': '一房一价详情页',
                '/building/value_analysis/main': '楼盘价值分析页'
            }
            let page = PAGE_MAP[path]
            if (typeof page === 'object') {
                page = page[type]
            }
            page = page || path
            sendCtmEvtLog(`${page}TOP${i + 1}置业顾问咨询点击`)
            openChat(id, {
                building_id: this.building_id,
                from: this.page || ''
            })                
        }
    }
}
